import type { ImageSourcePropType } from 'react-native';

import avatar1 from '../../assets/avatars/1.webp';
import avatar2 from '../../assets/avatars/2.webp';
import avatar3 from '../../assets/avatars/3.webp';
import avatar4 from '../../assets/avatars/4.webp';
import avatar5 from '../../assets/avatars/5.webp';
import avatar6 from '../../assets/avatars/6.webp';
import avatar7 from '../../assets/avatars/7.webp';
import avatar8 from '../../assets/avatars/8.webp';
import avatar9 from '../../assets/avatars/9.webp';
import avatar10 from '../../assets/avatars/10.webp';
import avatar11 from '../../assets/avatars/11.webp';
import avatar12 from '../../assets/avatars/12.webp';
import avatar13 from '../../assets/avatars/13.webp';
import avatar14 from '../../assets/avatars/14.webp';
import avatar15 from '../../assets/avatars/15.webp';
import avatar16 from '../../assets/avatars/16.webp';
import avatar17 from '../../assets/avatars/17.webp';
import avatar18 from '../../assets/avatars/18.webp';
import avatar19 from '../../assets/avatars/19.webp';
import avatar20 from '../../assets/avatars/20.webp';
import avatar21 from '../../assets/avatars/21.webp';
import avatar22 from '../../assets/avatars/22.webp';
import avatar23 from '../../assets/avatars/23.webp';
import avatar24 from '../../assets/avatars/24.webp';
import avatar25 from '../../assets/avatars/25.webp';
import avatar26 from '../../assets/avatars/26.webp';
import avatar27 from '../../assets/avatars/27.webp';
import avatar28 from '../../assets/avatars/28.webp';
import avatar29 from '../../assets/avatars/29.webp';
import avatar30 from '../../assets/avatars/30.webp';
import avatar31 from '../../assets/avatars/31.webp';
import avatar32 from '../../assets/avatars/32.webp';
import avatar33 from '../../assets/avatars/33.webp';
import avatar34 from '../../assets/avatars/34.webp';
import avatar35 from '../../assets/avatars/35.webp';
import avatar36 from '../../assets/avatars/36.webp';
import avatar37 from '../../assets/avatars/37.webp';
import avatar38 from '../../assets/avatars/38.webp';
import avatar39 from '../../assets/avatars/39.webp';
import avatar40 from '../../assets/avatars/40.webp';
import avatar41 from '../../assets/avatars/41.webp';
import avatar42 from '../../assets/avatars/42.webp';
import avatar43 from '../../assets/avatars/43.webp';
import avatar44 from '../../assets/avatars/44.webp';
import avatar45 from '../../assets/avatars/45.webp';
import avatar46 from '../../assets/avatars/46.webp';
import avatar47 from '../../assets/avatars/47.webp';
import avatar48 from '../../assets/avatars/48.webp';
import avatar49 from '../../assets/avatars/49.webp';
import avatar50 from '../../assets/avatars/50.webp';
import avatar51 from '../../assets/avatars/51.webp';
import avatar52 from '../../assets/avatars/52.webp';
import avatar53 from '../../assets/avatars/53.webp';
import avatar54 from '../../assets/avatars/54.webp';
import avatar55 from '../../assets/avatars/55.webp';
import avatar56 from '../../assets/avatars/56.webp';
import avatar57 from '../../assets/avatars/57.webp';
import avatar58 from '../../assets/avatars/58.webp';
import avatar59 from '../../assets/avatars/59.webp';
import avatar60 from '../../assets/avatars/60.webp';

const createImageSource = (uri: string): ImageSourcePropType => ({ uri });

const avatarList = [
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  avatar10,
  avatar11,
  avatar12,
  avatar13,
  avatar14,
  avatar15,
  avatar16,
  avatar17,
  avatar18,
  avatar19,
  avatar20,
  avatar21,
  avatar22,
  avatar23,
  avatar24,
  avatar25,
  avatar26,
  avatar27,
  avatar28,
  avatar29,
  avatar30,
  avatar31,
  avatar32,
  avatar33,
  avatar34,
  avatar35,
  avatar36,
  avatar37,
  avatar38,
  avatar39,
  avatar40,
  avatar41,
  avatar42,
  avatar43,
  avatar44,
  avatar45,
  avatar46,
  avatar47,
  avatar48,
  avatar49,
  avatar50,
  avatar51,
  avatar52,
  avatar53,
  avatar54,
  avatar55,
  avatar56,
  avatar57,
  avatar58,
  avatar59,
  avatar60,
] as const;

const PRESET_AVATARS = avatarList.reduce<Record<string, ImageSourcePropType>>((acc, uri, index) => {
  acc[`preset_${index + 1}`] = createImageSource(uri);
  return acc;
}, {});

export const getPresetAvatarAsset = (key?: string | null): ImageSourcePropType | undefined => {
  if (!key) return undefined;
  return PRESET_AVATARS[key] ?? undefined;
};

export const listPresetAvatarKeys = (): string[] => Object.keys(PRESET_AVATARS);
